export interface IParamsBase {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  orderBy?: string;
  isPaging?: boolean;
  queryFor?: QueryFor;
}

export class ParamsBase {
  search?: string;
  pageNumber?: number = 1;
  pageSize?: number = 50;
  orderBy?: string;
  isPaging?: boolean = true;
  queryFor?: QueryFor;
}

export enum QueryFor {
  None,
  TableView,
  Autocomplete
}
